import $ from "jquery";

class Search {

    constructor() {

        //this.resultsDiv = $("#search-overlay__results");
        this.searchField = $("#search-field");
        this.clearHistoryBtn = $("#clear-history-btn");
        this.searchCountryTabs = $(".popular-search-country-tab"); 

        this.events();
        this.isOverlayOpen = false;
        this.isSpinnerVisible = false;
        this.previousValue;
        this.typingTimer;
       
        
    }

    events() {
        this.searchField.on("click",this.openOverlay.bind(this));
        this.clearHistoryBtn.on("click",this.clearHistory.bind(this));
        this.searchField.on("keyup",this.autoSuggestion.bind(this));
        this.searchCountryTabs.on("click","li",this.showCountriesTop.bind(this));
        $(document).on("click", this.keyPressDispatcher.bind(this));
        //this.searchField.on("keyup", this.typingLogic.bind(this));
        // Fetch the suggestions with URLs from the JSON file
    }

    highlightTerm(text, term) {
        const regex = new RegExp("(" + $.ui.autocomplete.escapeRegex(term) + ")", "gi");
        return text.replace(regex, "<span class='highlight'>$1</span>");
    }

    clearHistory(e){
        //document.cookie = 'ootlah_search_history=; Max-Age=-99999999;';
        document.cookie = 'ootlah_search_history=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        $('#search-bar-history-section').remove();
    }

    showCountriesTop(e){
        var thisTab = $(e.target);
        var thisID = thisTab.data('id');
        $('.popular-search-country-tab li').removeClass('active');
        thisTab.addClass('active');
        $('.popular-search-country').removeClass('active');
        $('#popular-search-country-'+thisID).addClass('active');
    }

    autoSuggestion(e){
        var thisSearch = $(e.target);
       
        
        if(thisSearch.val()!=""){
            $('#search-box').hide();
            this.isOverlayOpen = false;
        }else{
            $('#search-box').show();
            this.isOverlayOpen = true;
        }
        
    }

    openOverlay() {
        if(this.isOverlayOpen === false){
            $('#search-box').show();
            this.isOverlayOpen = true;
        }
        
        return false;
    }

    closeOverlay() {
        this.searchOverlay.removeClass("search-overlay--active");
        $("body").removeClass("body-no-scroll");
        this.isOverlayOpen = false;
    }


    keyPressDispatcher(e) {
        
        if (!$(e.target).closest('#search-box').length && !$(e.target).is('#search-field')) {
            $('#search-box').hide();
            this.isOverlayOpen = false;
        }
    }
}

export default Search;